module.exports = __webpack_public_path__ + "static/RebelMouse-931d5cebd05634137e5ede0c394e6521.svg";